import { DashboardLayout } from '@/app/layouts/DashboardLayout'
import { Device } from '@/pages/panel/Device'
import NotFound from '@/pages/NotFound'
import {
  Dashboard,
  DealPage,
  Deals,
  FarmPage,
  FinancePage,
  Order,
  PayoutPage,
  Payouts,
  Profile,
  ReferralPage,
  Referrals,
  Requisites,
  RequisitPage,
} from '@/pages/panel'
import { Devices } from '@/pages/panel/Devices'
import Register from '@/pages/Register'
import { Navigate, useLocation } from 'react-router-dom'
import { LoginRedirect } from './LoginRedirect'
import { Orders } from '@/pages/panel/Orders'
import React from 'react'

export const publicRoutes = [
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: '/login', element: <LoginRedirect /> },
  { path: '/register', element: <Register /> },
  { path: '*', element: <NotFound /> },
]

// eslint-disable-next-line react-refresh/only-export-components
const PanelRedirect: React.FC = () => {
  const location = useLocation()
  const newPath = location.pathname.replace('/panel', '') || '/'
  return <Navigate to={newPath} replace />
}

export const protectedRoutes = [
  {
    path: '/panel/*',
    element: <PanelRedirect />,
  },
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'profile', element: <Profile /> },
      { path: 'deals', element: <Deals /> },
      { path: 'deals/:id', element: <DealPage /> },
      { path: 'payout', element: <Payouts /> },
      { path: 'payout/:id', element: <PayoutPage /> },
      { path: 'finance', element: <FinancePage /> },
      { path: 'orders', element: <Orders /> },
      { path: 'orders/:id', element: <Order /> },
      { path: 'requisites', element: <Requisites /> },
      { path: 'requisites/:id', element: <RequisitPage /> },
      { path: 'farm/:id', element: <FarmPage /> },
      { path: 'referrals', element: <Referrals /> },
      { path: 'referrals/:id', element: <ReferralPage /> },
      { path: 'devices', element: <Devices /> },
      { path: 'devices/:id', element: <Device /> },
      // { path: 'Integration', element: <Integration /> },
    ],
  },
]
